import { useTranslation } from 'react-i18next';
import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';
import { MountElementProps } from 'v5/messages/mount-element';
import { TransferToWorkspaceDialog } from 'v5/patterns/forms/dialogs/TransferToWorkspaceDialog';
import { WithServices } from 'v5/platform/ts/services';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';

export type TransferCalloutDialogProps = MountElementProps &
  WithServices<[WithEnterpriseService]> & {
    organizationId: string;
    calloutName: string;
    calloutCount?: number;
    currentWorkspaceId?: number | null;
    onSubmit: (workspace: EnterpriseWorkspace) => Promise<void>;
  };

export function TransferCalloutDialog({
  calloutName,
  calloutCount,
  ...props
}: TransferCalloutDialogProps) {
  const { t } = useTranslation('callouts', {
    keyPrefix: 'TransferCalloutDialog'
  });

  const descriptionMessage = t('description', {
    count: calloutCount,
    name: calloutName
  });

  return (
    <TransferToWorkspaceDialog
      {...props}
      titleMessage={t('title')}
      descriptionMessage={descriptionMessage}
      fieldWorkspaceMessage={t('fieldWorkspace')}
    />
  );
}
